import { z } from 'zod';

export const appEnvSchema = z.object({
  namespace: z.string(),
  segmentWriteKey: z.string(),
  launchDarklyClientSideId: z.string(),
  apiBaseUrl: z.string(),
  askAiBaseUrl: z.string().optional(),
  fimApiLocalBaseUrl: z.string().optional(),
  auth0ClientId: z.string(),
  auth0Domain: z.string(),
  auth0GoogleConnectionName: z.string().default('Google'),
  nexusRedirectUri: z.string(),
  loopAudience: z.string(),
  muiProLicenseId: z
    .string()
    .default(
      'fed3e794c60408bcf66e7485006ab20cTz0xMjE4NDcsRT0xNzk0NzAwNzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
    ),
  froalaLicenseId: z
    .string()
    .default('Ja2A4wB1D1D2F2H5C3H4B2C1pdzdNSWXa1c1MDe1CI1PLPFa1F1EESFKVlA6F6D5C4A1D3C10A3B5A5=='),
  portalsBaseUrl: z.string().optional(),
  feedbackFormUrl: z.string().optional(),
  bugReportUrl: z.string().optional(),
  internalFeedbackUrl: z.string().optional(),
  ddRumAppId: z.string().optional(),
  ddRumClientToken: z.string().optional(),
  ddEnv: z.string().optional(),
  amplitudeApiKey: z.string().optional(),
  slackClientId: z.string().optional(),
});

export const getEnv = (): z.output<typeof appEnvSchema> => {
  return appEnvSchema.parse(window.env);
};
